<template>
  <v-data-table
      dense
      hide-default-footer
      :headers="headers"
      :items="list"
      class="lotesListTable"
    >
      <!-- <template v-slot:item.pagto_estimado="{ item }">
        <b v-if="item.pagto_estimado">{{ item.pagto_estimado | formatPrice}}</b>
      </template> -->
      <!-- DESCOMENTAR PARA EXIBIR LOGIN INVÁLIDO -->
      <!-- <template v-slot:item.identificador_prestador="{ item }" >
           <v-menu right offset-y class="px-5" :nudge-width="250" max-width="250px" v-if="item.login_invalido" >
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" small color="error" icon>
                <v-icon small color="error">fa-exclamation-circle</v-icon>
              </v-btn>
            </template>
            <v-card >
              <v-card-text>
                <b>Login inválido!</b> <br>Click aqui para corrigir 
                  
                  <v-icon @click="setFilter(item, 'identNaOperadoraFilter')" small color="primary">fa-external-link-alt</v-icon>
                
              </v-card-text>
            </v-card>
          </v-menu>
          <span>{{ item.identificador_prestador }}</span>
      </template>  -->

      <template v-slot:item.valor_informado="{ item }">
        <b style="color:#D0021B"  v-if="item.valor_informado">{{ item.valor_informado | formatPrice }}</b>
      </template>
      <template v-slot:item.valor_liberado="{ item }">
        <b style="color:#32B88B" v-if="item.valor_liberado">{{ item.valor_liberado | formatPrice }}</b>
      </template>
      <template v-slot:item.valor_glosado="{ item }">
        <span style="color:#D0021B" v-if="item.valor_glosado">{{ item.valor_glosado  | formatPrice }}</span>
      </template>
      <template v-slot:item.valor_recursado="{ item }">
        <span style="color:#32B88B" >{{ item.valor_recursado | formatPrice }}</span>
      </template>
      <template v-slot:item.valor_acatado="{ item }">
        <span style="color:#31B1FF" >{{ item.valor_acatado | formatPrice }}</span>
      </template>
      <template v-slot:item.status="{ item }">

      <!-- <v-tooltip bottom v-if="item.is_edited || dadosPagamento.is_edited">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="pa-0 mr-2">
              <v-icon color="success" x-small>fa-check-circle</v-icon>
            </span>
          </template>
          <span 
            class="px-3 py-1 ma-0"
            style="
                  border: solid 1px #999;
                  border-radius: 5px;
                  background-color: #fff;
                "
            >Editado</span >
        </v-tooltip> -->

          <!-- <v-tooltip bottom v-if="(item.is_editing && ['50', '70'].includes(dadosPagamento.etapa) && !!item.username_editing && item.username_editing!=userName)">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="pa-0  ml-1">
              <v-progress-circular
                  :size="12"
                  :width="1"
                  color="primary"
                  indeterminate
                  class="pt-7"
                ></v-progress-circular>
            </span>
          </template>
          <span 
            class="px-3 py-1 ma-0"
            style="
                  border: solid 1px #999;
                  border-radius: 5px;
                  background-color: #fff;
                "
            >Em análise {{item.username_editing? `por ${item.username_editing}`: 'do pagamento integral'}}</span >
        </v-tooltip> -->

         <v-tooltip bottom open-delay="50"  v-if="item.perc_lotes_concluidos && ['70', '80', '99'].includes(dadosPagamento.etapa)">
          <template v-slot:activator="{ on, attrs }">
              <span>{{item.perc_lotes_concluidos}}%
              <v-icon x-small class="pb-1 ml-0 mr-2" color="primary" v-bind="attrs" v-on="on">fas fa-paper-plane</v-icon>
              </span>
          </template>
          <span class="px-3 py-1 ma-0"
          style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
          >enviado à operadora</span>
      </v-tooltip>
      <v-tooltip bottom open-delay="50" v-if="item.perc_lotes_erros && ['70', '80', '99'].includes(dadosPagamento.etapa)">
          <template v-slot:activator="{ on, attrs }">
              <span>{{item.perc_lotes_erros}}%
              <v-icon x-small class="pb-1 ml-0 mr-2" color="error" v-bind="attrs" v-on="on">far fa-paper-plane</v-icon>
              </span>
          </template>
          <span class="px-3 py-1 ma-0"
          style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
          >com erro no envio</span>
      </v-tooltip>
      
      <!-- <v-btn 
            v-if="(item.is_editing && !item.is_edited && item.username_editing==userName && !dadosPagamento.is_edited) ||
              (!item.is_editing && !item.is_edited && ['40', '50', '80'].includes(dadosPagamento.etapa) && !dadosPagamento.is_editing && !dadosPagamento.is_edited) || 
              (!dadosPagamento.is_edited && !item.is_edited && dadosPagamento.is_editing && dadosPagamento.username_editing==userName)"
            class="ma-0  mr-2"
            :color="dadosPagamento.etapa=='80'? 'error' : 'primary'"
            :disabled="item.is_editing && item.username_editing!=userName"
            x-small
            icon
            @click="$router.replace({path:'/recebiveis/recursosdeglosa/recursosdeglosaedicao/'+item.id})"
          ><v-icon x-small>fa-pencil-alt</v-icon></v-btn> -->

          <!-- <v-btn 
            v-if="enableLiberarEdicao(item)"
            class="ma-0  mr-2"
            color="primary"
            x-small
            icon
            @click="confirmLiberarEdicao(item)"
          ><v-icon x-small>fa-unlock-alt</v-icon></v-btn> -->

       </template>
       <template v-slot:item.acoes="{ item }">
           <v-btn 
            v-if="dadosPagamento.etapa==90"
            class="ma-0"
            color="error"
            x-small
            icon
          ><v-icon x-small>far fa-eye</v-icon></v-btn>
          <v-btn 
            v-if="((item.is_editing && item.username_editing==userName) || (!item.is_editing && ['40', '50', '70'].includes(dadosPagamento.etapa)))"
            class="ma-0"
            :color="dadosPagamento.etapa==90? 'error' : 'primary'"
            :disabled="item.is_editing && item.username_editing!=userName"
            x-small
            icon
            @click="$router.push({path:'/recebiveis/recursosdeglosaedicao/'+item.id})"
          ><v-icon x-small>fa-pencil-alt</v-icon></v-btn>
          <v-tooltip bottom v-if="(item.is_editing && item.username_editing!=userName)">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="pa-0  ml-1">
              <v-progress-circular
                  :size="12"
                  :width="1"
                  color="primary"
                  indeterminate
                  class="pt-7"
                ></v-progress-circular>
            </span>
          </template>
          <span 
            class="px-3 py-1 ma-0"
            style="
                  border: solid 1px #999;
                  border-radius: 5px;
                  background-color: #fff;
                "
            >Em análise por {{item.username_editing}}</span >
        </v-tooltip>
       </template>
    </v-data-table>
</template>

<script>
//import identificacao_operadoras from "../views/IdentificacaoOperadora" 
//
export default {
  components:{
    //identificacao_operadoras
  },
    props:{
      confirmLiberarEdicao: Function,
      dadosPagamento: Object,
      headers: Array,
      list: Array,
      userName: String,
      userData: Object
    },
    methods:{
      enableLiberarEdicao(pagamento){
        let podeLiberarEdicao = this.userData 
                                && (this.userData.Permissao.faturamento.includes('gestor') || this.userData.Permissao.faturamento.includes('coordenador'))
                                && pagamento.is_editing 
                                && pagamento.username_editing != this.userName
        return podeLiberarEdicao
      },
      setFilter(item, filterName){
        let login_valido = !item.login_invalido
        let operadora_ans_id = [Number(item.operadora_ans_id)]
        let prestador_id = [Number(item.prestador_id)]
        let grupo_economico = this.$store.state.permissions.grupoEconomico
        let filter = {
          filterData: {
            grupo_economico,
            login_valido,
            operadora_ans_id, 
            prestador_id,
          },
          filterName: filterName? filterName :'identNaOperadoraFilter',
          redirect: true
        }
        this.$store.commit('recebiveis/setFilter', filter, { root:true })
      }
    }
}
</script>

<style>

</style>